import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  constructor(private storageService: StorageService) {}

  public storeSort(event: Sort, data, view?: string): any {
    data.sort((a, b) => {
      let compareAux: number;
      const isAsc = event.direction === 'asc';
      switch (event.active) {
        case 'deviceName':
        case 'developer':
        case 'fullName':
        case 'name':
        case 'description':
        case 'nmeBatch':
        case 'author':
          return this.compare(a[event.active].toLowerCase(), b[event.active].toLowerCase(), isAsc);
        case 'alive':
        case 'deviceAlive':
          compareAux = this.compare(a.alive || a.deviceAlive, b.alive || b.deviceAlive, isAsc);
          return compareAux === 0 ? this.compare(a.name, b.name, isAsc) : compareAux;
        case 'status':
          if (a.actived) {
            compareAux = this.compare(a.activated, b.activated, isAsc);
            return compareAux === 0 ? this.compare(a.name, b.name, isAsc) : compareAux;
          } else {
            compareAux = this.compare(a.status, b.status, isAsc);
            return compareAux === 0 ? this.compare(a.name, b.name, isAsc) : compareAux;
          }
        case 'running':
          compareAux = this.compare(a.runningApps, b.runningApps, isAsc);
          return compareAux === 0
            ? this.compare(a.installedApps, b.installedApps, isAsc)
            : compareAux;
        default:
          return this.compare(a[event.active], b[event.active], isAsc);
      }
    });
    if (view === undefined) {
      view = '';
    }
    this.storageService.storeListSorting(JSON.stringify(event), view);
    return data;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a === b) {
      return 0;
    }
    return (a < b ? -1 : 1) * (isAsc ? -1 : 1);
  }
}
